import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { ContasRelatorioInadimplentes } from "features/relatorios/typings";
import moment from "moment";
import { formatMoney } from "infra/helpers/number";
import { Row, Col } from "antd";

interface TableItemRowProps {
  conta: ContasRelatorioInadimplentes;
}
function TableItemRow({ conta }: TableItemRowProps) {
  return (
    <Flex as={Row} gutter={4} w="100%">
      <Flex as={Col} xs={2}>
        <Flex ml={"46px"} flexDir="column">
          {conta.composicoes?.map((composicao) => (
            <Text key={composicao.id}>
              {composicao.breadcrumb} {composicao.nome}
            </Text>
          ))}
        </Flex>
      </Flex>
      <Flex as={Col} xs={3}>
        <Flex>{conta.descricao}</Flex>
      </Flex>
      <Flex as={Col} xs={2}>
        <Flex>{moment(conta.dataVencimento).format("DD/MM/YYYY")}</Flex>
      </Flex>
      <Flex as={Col} xs={1}>
        <Flex>
          {conta.dataCompetencia
            ? moment(conta.dataCompetencia).format("MM/YYYY")
            : "--"}
        </Flex>
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end">
        {conta.nossoNumero ?? "--"}
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end">
        {formatMoney(conta.principal)}
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end">
        {formatMoney(conta.multa)}
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end">
        {formatMoney(conta.juros)}
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end">
        {formatMoney(conta.valorTaxaCobranca)}
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end">
        {formatMoney(conta.valorCorrecaoMonetaria)}
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end">
        {conta.diasAtraso}
      </Flex>
      <Flex as={Col} xs={2} justifyContent="flex-end">
        {formatMoney(conta.total)}
      </Flex>
    </Flex>
  );
}

export default TableItemRow;
